module.exports = __webpack_public_path__ + "afe4b4f21de8cfb22d899db00b0fdd8b.MP3";